import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AuthState } from '../reducers/auth.reducer';

export const selectAuth = createFeatureSelector<AuthState>('auth');

export const isAuthentified = createSelector(
    selectAuth,
    state => state.authentified
  );

export const idToken = createSelector(
  selectAuth,
  state => state.authentified ? state.user.id_token : null
);

export const getAuthNUser = createSelector(
  selectAuth,
  state => state.user
);

export const isUserApprenant = createSelector(
  selectAuth,
  state => state.userIsPasswordlessApprenant
)

export const getApprenantUUID = createSelector(
  selectAuth,
  state => state.user.profile.idApprenant
)
